import { render } from "./SendThanksMobileIcon.vue?vue&type=template&id=57c91448"
import script from "./SendThanksMobileIcon.vue?vue&type=script&lang=js"
export * from "./SendThanksMobileIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__